/**
 * Панель разработчиков: сайдбар с вкладками и контент.
 */

import { useState } from "react";
import { clearDevToken } from "../../utils/devAuth";
import useDevOverview from "../../hooks/useDevOverview";
import DevLayout from "./DevLayout";
import DevDashboard from "./DevDashboard";
import DevChats from "./DevChats";

function DevPanel({ token, onLogout }) {
    const [tab, setTab] = useState("dashboard");
    const { overview, error, loading } = useDevOverview(token, onLogout);

    const handleLogout = () => {
        clearDevToken();
        onLogout();
        console.info("Выход из админки");
    };

    return (
        <DevLayout tab={tab} onTab={setTab} onLogout={handleLogout}>
            {tab === "dashboard" ? (
                <DevDashboard overview={overview} error={error} loading={loading} />
            ) : (
                <DevChats sessions={overview?.sessions} error={error} loading={loading} />
            )}
        </DevLayout>
    );
}

export default DevPanel;
// components/DevAdmin/DevPanel.js
